<h1 mat-dialog-title>{{ dialogText.title }}</h1>
<mat-icon mat-dialog-close class="close">close</mat-icon>

<div mat-dialog-content>
  <div>{{ dialogText.contentLine1 }}</div>
  <div>{{ dialogText.contentLine2 }}</div>
</div>

<div mat-dialog-actions>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ dialogText.confirm }}</button>
</div>
